module.exports = __webpack_public_path__ + "static/travel-tips-add-tab-98188f6e071ab6638d9d11d961f8858f.png";